"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.capPosition = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const noop_1 = __importDefault(require("lodash/noop"));
const DeleteCardButton_1 = __importDefault(require("../../atoms/DeleteCardButton"));
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
const draggable_1 = require("../../utils/draggable");
function capPosition(position, windowSize, guidesWidth) {
    const INSETS = {
        top: 50 / windowSize.height,
        right: 10 / windowSize.width,
        bottom: 75 / windowSize.height,
        left: 10 / windowSize.width,
    };
    const x = Math.max(INSETS.left, Math.min(position.x + guidesWidth / windowSize.width, 1 - INSETS.right - (280 + guidesWidth) / windowSize.width));
    const y = Math.max(INSETS.top, Math.min(position.y, 1 - INSETS.bottom));
    return { x, y };
}
exports.capPosition = capPosition;
const EMPTY_PARTS = [];
// eslint-disable-next-line max-lines-per-function
function LabelCard({ identifier, type, defaultPosition, locked, onDoubleClick = noop_1.default, onClickOutside = noop_1.default, onRectUpdate = noop_1.default, className, children, isExpanded = false, parts = EMPTY_PARTS, textRef, editable, originalPosRef, }) {
    var _a;
    const bridge = (0, bridge_1.useBridge)();
    const { isDesktop } = (0, device_1.usePlatform)();
    const [isSelected, setIsSelected] = (0, react_1.useState)(false);
    const windowSize = (0, ui_1.useScreenSize)();
    const { selectedLabelID } = (0, hooks_1.useLabels)();
    // const latestLabel = useLatestLabel();
    const [{ isGuidesAvailable, guidesGridWidth }] = (0, providers_1.useGuidesContext)();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [position, setPosition] = (0, react_1.useState)(defaultPosition);
    const containerRef = (0, react_1.useRef)(null);
    const deleteButtonRef = (0, react_1.useRef)(null);
    const labelRect = (0, react_1.useRef)({
        identifier,
        rect: {
            x: defaultPosition.x,
            y: defaultPosition.y,
            width: 0,
            height: 0,
        },
        parts: {},
    });
    (0, react_1.useEffect)(() => {
        if (identifier === selectedLabelID) {
            setIsSelected(true);
        }
    }, [identifier, selectedLabelID]);
    (0, draggable_1.useMouseEvents)(identifier, type, parts, isExpanded, textRef, originalPosRef);
    const labelsState = (0, hooks_1.useLabels)();
    const originalScreenSize = ((_a = labelsState === null || labelsState === void 0 ? void 0 : labelsState.labels.find(label => label.identifier === identifier)) === null || _a === void 0 ? void 0 : _a.screenSize) || [1037, 778];
    const tools = (0, providers_1.useToolsService)();
    const labelToolManager = tools === null || tools === void 0 ? void 0 : tools.getLabelToolManager();
    const { isMobile } = (0, device_1.usePlatform)();
    const originalPositionRef = (0, react_1.useRef)(defaultPosition);
    // const isDraggingRef = useRef(false) as MutableRefObject<boolean>;
    (0, react_1.useEffect)(() => {
        if (type === bridge_schema_1.LabelType.Default) {
            originalPositionRef.current = defaultPosition;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultPosition]);
    const onDelete = (0, react_1.useCallback)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.labelDelete(identifier);
        if ((labelsState === null || labelsState === void 0 ? void 0 : labelsState.isGroupMode) === true) {
            labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.resetGroupMode();
            bridge === null || bridge === void 0 ? void 0 : bridge.exitLabelGroupMode();
            localStorage.removeItem('groupModeID');
        }
        labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.removeLabel(identifier);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [identifier]);
    const onClick = () => {
        // if (isDraggingRef.current) {
        //   return;
        // }
        if (selectedLabelID === identifier) {
            return;
        }
        setIsSelected(true);
        // setShowLabelLines(true);
        labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.selectLabel(identifier);
    };
    const onDeleteHandler = (event) => {
        event.stopPropagation();
        onDelete();
    };
    // useEffect(() => {
    //   if (latestLabel === null && selectedLabelID === identifier) {
    //     onClickOutside();
    //     setIsSelected(false);
    //     labelToolManager?.deselectLabel();
    //     setIsPartExplicitlySelected(false);
    //   }
    // }, [
    //   identifier,
    //   labelToolManager,
    //   latestLabel,
    //   onClickOutside,
    //   selectedLabelID,
    //   setIsPartExplicitlySelected,
    // ]);
    const handleOnClickOutside = () => {
        onClickOutside();
        setIsSelected(false);
        labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.deselectLabel();
    };
    (0, react_1.useEffect)(() => {
        setPosition(defaultPosition);
    }, [defaultPosition]);
    (0, react_1.useEffect)(() => {
        requestAnimationFrame(() => {
            if (!containerRef.current) {
                return;
            }
            const rect = containerRef.current.getBoundingClientRect();
            labelRect.current.rect = {
                x: rect.left,
                y: rect.top,
                width: rect.width,
                height: rect.height,
            };
            onRectUpdate(labelRect.current.rect);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onRectUpdate]);
    const events = (0, ui_1.getPointersEvents)();
    const onDoubleClickHandler = () => {
        if (selectedLabelID !== identifier) {
            onClick();
        }
        onDoubleClick();
    };
    (0, ui_1.useEvent)(deleteButtonRef, events.down, onDeleteHandler);
    (0, ui_1.useDoubleClick)(containerRef, true, onClick, onDoubleClickHandler);
    // useOutsideClick(containerRef, handleOnClickOutside, [
    //   '.tools-header',
    //   '#toolkit-panel',
    //   '.main-menu-container',
    // ]);
    (0, ui_1.useOutsideClick)(containerRef, () => {
        // Only execute the click outside logic if the label is selected
        if (selectedLabelID === identifier && !editable) {
            handleOnClickOutside();
        }
    }, ['.tools-header', '#toolkit-panel', '.main-menu-container']);
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, className: className, "$position": capPosition(position, windowSize, isGuidesAvailable ? guidesGridWidth : 0), "$locked": locked, "$windowSize": windowSize, "$originalWindowSize": {
            width: originalScreenSize[0],
            height: originalScreenSize[1],
        }, id: identifier, "$isMobile": isMobile, "data-e2e": 'LabelCard_Container', children: [children, (0, jsx_runtime_1.jsx)(StyledDeleteCardButton, { ref: deleteButtonRef, desktop: isDesktop, visible: isSelected, iconSize: 10, onClick: () => onDeleteHandler, "data-e2e": 'LabelCard_StyledDeleteCardButton' })] }));
}
exports.default = LabelCard;
const Container = styled_components_1.default.div `
  position: absolute;
  top: ${({ $position, $windowSize }) => $position.y * $windowSize.height}px;
  left: ${({ $position, $windowSize, $originalWindowSize }) => {
    const proportionalWidth = $originalWindowSize.height / 0.75; // 0.75 is the aspect ratio of 3:4 screen
    const offset = ($originalWindowSize.width - proportionalWidth) / 2;
    // left-side labels are adjusted to the left
    const adjustedX = $position.x < 0.5
        ? ($position.x * $originalWindowSize.width - offset) /
            $originalWindowSize.width
        : $position.x;
    const originalScreenRatio = $originalWindowSize.height / $originalWindowSize.width;
    // if the original screen ratio is less than 0.55, the label is considered to be on the left side
    return originalScreenRatio <= 0.55
        ? adjustedX * $windowSize.width
        : $position.x * $windowSize.width;
}}px;

  display: flex;

  width: 280px;

  background: ${({ theme }) => theme.backgroundSecondary};
  box-shadow: ${({ theme }) => theme.tools.pen.button.shadow};

  opacity: ${({ $locked }) => ($locked ? 0.65 : 1)};

  user-select: none;

  pointer-events: all;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    margin: 0;
  `)}

  ${({ $isMobile }) => $isMobile &&
    ui_1.deviceLandscape.all((0, styled_components_1.css) `
      position: relative;
      top: auto;
      left: auto;
      width: 100%;
      margin: 5px 0;
    `)}
`;
const StyledDeleteCardButton = (0, styled_components_1.default)(DeleteCardButton_1.default) `
  position: absolute;
  top: -10px;
  left: -10px;

  width: 20px;
  height: 20px;

  box-shadow: ${({ theme }) => theme.tools.pen.button.shadow};

  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible, desktop }) => visible || desktop ? 'auto' : 'none'};

  ${({ desktop }) => desktop &&
    (0, styled_components_1.css) `
      ${Container}:hover & {
        opacity: 1;
      }
    `}
`;
